import { render, staticRenderFns } from "./editExamineStaffList.vue?vue&type=template&id=38a71ba2&scoped=true"
import script from "./editExamineStaffList.vue?vue&type=script&lang=js"
export * from "./editExamineStaffList.vue?vue&type=script&lang=js"
import style0 from "./editExamineStaffList.vue?vue&type=style&index=0&id=38a71ba2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a71ba2",
  null
  
)

export default component.exports